import styled from "styled-components";
import Colors from "../../../../Constant/Colors";
import { STYLES } from "../../../../Constant/Theme";

export const Container = styled.div`
  display:  flex;
  width: 75%;
  min-width: 390px;
  height: 100%;
  flex-direction: column;
  box-sizing: border-box;
  padding: 30px;
  
  
  @media only screen and (max-width: 600px) {
    width: 180px;
  }
  `;
export const MainDiv = styled.div`
${STYLES.borderShadow};
${STYLES.VerticalLeftAlign};
border-top-right-radius: 10px;
border-top-left-radius: 10px;
height: 100%;

`;
export const HeadRow = styled.div`
${STYLES.spaceBetween};
box-sizing: border-box;
background-color: #000;
border-top-right-radius: 10px;
border-top-left-radius: 10px;
padding:10px;
`;

export const EachRow = styled.div`
${STYLES.HorizontalLeftAlign};
box-sizing: border-box;
width: 100%;
border-bottom: 1px solid ${Colors.lightGray};
padding: 10px;
`;



export const Editor = styled.div`
width: 100%;
height: 100%;
overflow-y: scroll;
&::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
border: 1px solid #fff ;
border-radius: 5px;
padding: 5px;
box-sizing: border-box;
background-color: white;
/* Styles for RichTextEditor */
.toolbar {
   border: none !important;
   /* Toolbar styles */
  }
  
  .editor {
    border: 1px solid #fff;
    border: none !important;
    /* Editor styles */
  }

`;